import './App.css'
// import AppComponent from './App.tsx'
import { useMemo } from 'react'
import { ThemeProvider, CssBaseline } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { createTheme, alpha } from '@mui/material/styles'
// #03030f


// TODO: primary #02ccaf

const primaryHue = '#18eaed';
const primaryHueDark = '#00c7c8';
const primaryHueLight = '#6af4f6';
const secondaryHue = '#7b68ff';
const secondaryHueDark = '#5a42ff';
const secondaryHueLight = '#a598ff';

const darkTheme = createTheme(
  createTheme({ palette: { mode: 'dark' } }), {
    palette: {
      // primary: { main: primaryHue, light: primaryHueLight, dark: primaryHueDark, contrastText: '#021012' },
      // secondary: { main: secondaryHue, light: secondaryHueLight, dark: secondaryHueDark, contrastText: '#0b0618' },
      // background: { default: '#0c111f', paper: '#060914f0', opaque: '#060914d9', bold: '#060914c2' },
      // divider: 'rgba(255,255,255,0.12)',
      // text: { primary: 'rgba(255,255,255,0.92)', secondary: 'rgba(255,255,255,0.7)' },
    },
  }
);
const lightTheme = createTheme(
  createTheme({ palette: { mode: 'light' } }), {
    palette: {
      // primary: { main: primaryHue, light: primaryHueLight, dark: primaryHueDark, contrastText: '#011012' },
      // secondary: { main: secondaryHue, light: secondaryHueLight, dark: secondaryHueDark, contrastText: '#0b0618' },
      // background: { default: '#f2f6fb', paper: '#ffffffef', opaque: '#ffffffd9', bold: '#ffffffc2' },
      // divider: 'rgba(0,0,0,0.08)',
      // text: { primary: 'rgba(2,6,23,0.92)', secondary: 'rgba(2,6,23,0.6)' },
    },
  }
);

export default function Theme({ children }: { children: React.ReactNode }) {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  // console.log('Prefers dark mode:', prefersDarkMode)
  const theme = useMemo(() => {
    const theme = prefersDarkMode ? darkTheme : lightTheme;
    return createTheme(theme, {
      typography: {
        fontSize: 18,
        htmlFontSize: 16,
      },
      palette: {
        error: { main: '#fe1048', dark: '#c80036', light: '#ff456e', darker: '#870029' },
      },
      shape: { borderRadius:6 },
      components: {
          MuiPaper: {
            styleOverrides: {
              root: {
                backgroundImage: 'none',
                // color: 'rgba(255,255,255,0.92)',
                // backdropFilter: 'blur(8px) saturate(1.05)',
                // WebkitBackdropFilter: 'blur(8px) saturate(1.05)',
                // border: '1px solid rgba(255,255,255,0.08)',
                // boxShadow: '0 8px 24px rgba(0,0,0,0.35)'
              },
            },
            variants: [
              // { props: { elevation: 0 }, style: { backdropFilter: 'blur(0px) saturate(1.02)', WebkitBackdropFilter: 'blur(0px) saturate(1.02)', boxShadow: '0 2px 2px rgba(0,0,0,0.18)' } },
              // { props: { elevation: 1 }, style: { backdropFilter: 'blur(2px) saturate(1.06)', WebkitBackdropFilter: 'blur(2px) saturate(1.06)', boxShadow: '0 6px 8px rgba(0,0,0,0.28)' } },
              // { props: { elevation: 2 }, style: { backdropFilter: 'blur(4px) saturate(1.08)', WebkitBackdropFilter: 'blur(4px) saturate(1.08)', boxShadow: '0 8px 24px rgba(0,0,0,0.28)' } },
              // { props: { elevation: 3 }, style: { backdropFilter: 'blur(12px) saturate(1.1)', WebkitBackdropFilter: 'blur(12px) saturate(1.1)', boxShadow: '0 10px 28px rgba(0,0,0,0.38)' } },
              { props: { elevation: 0 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.96), backdropFilter: 'blur( 0px) saturate(1.02)', WebkitBackdropFilter: 'blur( 0px) saturate(1.02)' } },
              { props: { elevation: 1 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.84), backdropFilter: 'blur( 2px) saturate(1.06)', WebkitBackdropFilter: 'blur( 2px) saturate(1.06)' } },
              { props: { elevation: 2 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.72), backdropFilter: 'blur( 4px) saturate(1.08)', WebkitBackdropFilter: 'blur( 4px) saturate(1.08)', boxShadow: '0 2px  6px rgba(0,0,0,0.28)' } },
              { props: { elevation: 3 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.60), backdropFilter: 'blur(12px) saturate(1.10)', WebkitBackdropFilter: 'blur(12px) saturate(1.10)', boxShadow: '0 2px 12px rgba(0,0,0,0.28)' } },
              { props: { elevation: 4 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.40), backdropFilter: 'blur(16px) saturate(1.12)', WebkitBackdropFilter: 'blur(16px) saturate(1.12)', boxShadow: '0 2px 16px rgba(0,0,0,0.28)' } },
              { props: { elevation: 5 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.10), backdropFilter: 'blur(18px) saturate(1.13)', WebkitBackdropFilter: 'blur(18px) saturate(1.13)', boxShadow: '0 2px 18px rgba(0,0,0,0.28)' } },
              { props: { elevation: 6 }, style: { backgroundColor: alpha(theme.palette.background.paper, 0.00), backdropFilter: 'blur(20px) saturate(1.14)', WebkitBackdropFilter: 'blur(20px) saturate(1.14)', boxShadow: '0 2px 20px rgba(0,0,0,0.28)' } },
            ]
          },
        // MuiButton: { styleOverrides: { root: { textTransform: 'none', borderRadius: 10 } } },
        MuiTooltip: {
        //   defaultProps: { arrow: true },
          styleOverrides: {
            tooltip: {
              backgroundColor: theme.palette.background.paper,
        //       backgroundColor: 'rgba(17,24,39,0.92)',
        //       color: 'white',
        //       backdropFilter: 'blur(6px)',
        //       WebkitBackdropFilter: 'blur(6px)',
        //       border: '1px solid rgba(255,255,255,0.1)'
            },
        //     arrow: { color: 'rgba(17,24,39,0.92)' }
          }
        },
        // MuiButton: {
        //   styleOverrides: {
        //     root: {
        //       textTransform: 'none',
        //       fontWeight: 700,
        //       // borderRadius: 12,
        //       // paddingLeft: 16,
        //       // paddingRight: 16,
        //       // paddingTop: 0,
        //       // paddingBottom: 0,
        //     },
        //     containedPrimary: {
        //       background: `linear-gradient(135deg, ${primaryHue} 0%, ${primaryHueLight} 100%)`,
        //       color: '#021012',
        //       boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
        //       '&:hover': {
        //         background: `linear-gradient(135deg, ${primaryHueLight} 0%, ${primaryHue} 100%)`,
        //         boxShadow: '0 10px 28px rgba(0,0,0,0.32)',
        //       },
        //     },
        //     containedSecondary: {
        //       background: `linear-gradient(135deg, ${secondaryHue} 0%, ${secondaryHueLight} 100%)`,
        //       color: '#0b0618',
        //       boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
        //       '&:hover': {
        //         background: `linear-gradient(135deg, ${secondaryHueLight} 0%, ${secondaryHue} 100%)`,
        //         boxShadow: '0 10px 28px rgba(0,0,0,0.32)',
        //       },
        //     },
        //     outlinedPrimary: {
        //       borderWidth: 2,
        //       '&:hover': {
        //         borderWidth: 2,
        //         borderColor: primaryHue,
        //         backgroundColor: alpha(primaryHue, 0.08),
        //       },
        //     },
        //   },
        // },
      },

    });
    }, [prefersDarkMode])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
